<template>
    <heads>
        <div class="flex space-x-4">
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg w-5/6">
                <loading :showLoading="form.processing"/>
                <div :class="{ 'opacity-50': form.processing, 'opacity-100': !form.processing }">
                    <p class="text-lg font-medium mb-4">Add Application</p>
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-4 items-center">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Title'"/>
                                <breeze-input required v-model="form.title" class="w-full"/>
                                <breeze-input-error :message="form.errors ? form.errors.title : ''"/>
                            </div>
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Application Format'" class="mb-1"/>
                                <vue-editor id="editor" v-model="form.application"></vue-editor>
                                <breeze-input-error :message="form.errors ? form.errors.application : ''"/>
                                <span class="text-gray-600 font-medium">Note: Write custom variable in
                                    <code>::variable::</code> format like require parent mobile so use
                                    <code>::parentmobile::</code></span>
                            </div>
                            <div>
                                <breeze-label :required="true" :value="'Limit'"/>
                                <breeze-input required type="number" v-model="form.limit" class="w-full"/>
                                <breeze-input-error :message="form.errors ? form.errors.limit : ''"/>
                            </div>
                            <div>
                                <breeze-label :value="'Status'"/>
                                <breeze-checkbox required v-model="form.status" :checked="form.status"/>
                                <breeze-input-error :message="form.errors ? form.errors.status : ''"/>
                            </div>
                            <div>
                                <breeze-label :value="'Teacher'"/>
                                <input-checkbox class="rounded-full" type="radio" required v-model="form.type"
                                                :checked="form.type == 'teacher'" value="teacher" name="type"/>
                                <breeze-input-error :message="form.errors ? form.errors.type : ''"/>
                            </div>
                            <div>
                                <breeze-label :value="'Student'"/>
                                <input-checkbox class="rounded-full" type="radio" required v-model="form.type"
                                                :checked="form.type == 'student'" value="student" name="type"/>
                                <breeze-input-error :message="form.errors ? form.errors.type : ''"/>
                            </div>
                            <div class="col-span-2">
                                <breeze-button :type="'button'" @click="generateVariables">Generate Variables
                                </breeze-button>
                            </div>
                        </div>
                        <h3 class="py-2 text-xl" v-if="form.variables.length">Add labels to custom variables</h3>
                        <div class="grid grid-cols-4 gap-4 mb-4 items-center" v-for="vars, index in form.variables"
                             :key="index">
                            <div>
                                <breeze-label :value="'Variable'"/>
                                <breeze-input v-model="form.variables[index].variable" required readonly
                                              class="w-full"/>
                            </div>
                            <div>
                                <breeze-label :value="'Type'"/>
                                <breeze-select class="w-full" v-model="form.variables[index].type">
                                    <template #options>
                                        <option value="text">Text</option>
                                        <option value="number">Number</option>
                                        <option value="date">Date</option>
                                    </template>
                                </breeze-select>
                            </div>
                            <div class="col-span-2">
                                <breeze-label :value="'Label'"/>
                                <breeze-input v-model="form.variables[index].label" required class="w-full"/>
                            </div>
                        </div>
                        <button-link :href="route('heads.application.list')" class="bg-red-500 mr-4 hover:bg-red-400">
                            Cancel
                        </button-link>
                        <breeze-button :disabled="form.processing">Save</breeze-button>
                        <exception/>
                    </form>
                </div>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg w-1/6">
                <p class="text-sm font-medium mb-4">Copy placeholder variables and paste in application format
                </p>

                <input type="text" id="copy-code" :value="copiedText">
                <div class="space-y-2 mt-2">

                    <div id="FirstName"
                         class="bg-gray-100 text-center rounded-md p-2 cursor-pointer relative copy-block"
                         @click="copyText($event, '#FirstName#')">
                        First Name
                        <span id="FirstNameMassage" class="text-green-700 text-center my-auto text-xs"></span>
                    </div>
                    <div id="LastName" class="bg-gray-100 text-center rounded-md p-2 cursor-pointer relative copy-block"
                         @click="copyText($event, '#LastName#')">
                        Last Name
                        <span id="LastNameMassage" class="text-green-700 text-center text-xs right-2 mt-1"></span>
                    </div>
                    <div id="RefNo" class="bg-gray-100 text-center rounded-md p-2 cursor-pointer relative copy-block"
                         @click="copyText($event, '#RefNo#')">
                        Ref No
                        <span id="RefNoMassage" class="text-green-700 text-center text-xs right-2 mt-1"></span>
                    </div>
                    <div id="BranchHeadName"
                         class="bg-gray-100 text-center rounded-md p-2 cursor-pointer relative copy-block"
                         @click="copyText($event, '#BranchHeadName#')">
                        Branch Head Name
                        <span id="BranchHeadNameMassage" class="text-green-700 text-center text-xs right-2 mt-1"></span>
                    </div>
                    <div id="FullName" class="bg-gray-100 text-center rounded-md p-2 cursor-pointer relative copy-block"
                         @click="copyText($event, '#FullName#')">
                        Full Name
                        <span id="FullNameNameMassage" class="text-green-700 text-center text-xs right-2 mt-1"></span>
                    </div>
                    <div id="Date" class="bg-gray-100 text-center rounded-md p-2 cursor-pointer relative copy-block"
                         @click="copyText($event, '#Date#')">
                        Date
                        <span id="DateMassage" class="text-green-700 text-center text-xs right-2 mt-1"></span>
                    </div>
                </div>
            </div>
        </div>

    </heads>
</template>

<script>
import Heads from '@/Pages/Heads/Heads'
import BreezeInput from '@/Components/Input'
import BreezeSelect from '@/Components/Select'
import BreezeLabel from '@/Components/Label'
import BreezeCheckbox from '@/Components/Checkbox'
import InputCheckbox from '@/Components/InputCheckbox'
import BreezeButton from '@/Components/Button'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'
import Loading from '@/Components/Loading'
import {VueEditor} from "vue3-editor";

export default {
    components: {
        Heads,
        BreezeSelect,
        InputCheckbox,
        ButtonLink,
        BreezeInput,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        Exception,
        Loading,
        BreezeCheckbox,
        VueEditor
    },
    data() {
        return {
            form: useForm({
                title: '',
                application: '',
                type: '',
                limit: '',
                variables: [],
                status: true,
            }),
            copiedText: '',
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('heads.application.store'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
        copyText(event, text) {
            const el = document.createElement('textarea');
            el.value = text;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            if (selected) {
                document.getSelection().removeAllRanges();
                document.getSelection().addRange(selected);
            }

            let span = event.currentTarget.querySelector('span');

            if (span) {
                document.getElementById(event.target.id).classList.add('border', 'border-green-500')

                document.getElementById(span.id).innerHTML = ' Copied!';
                setTimeout(function () {
                    document.getElementById(span.id).innerHTML = '';

                    document.getElementById(event.target.id).classList.remove('border', 'border-green-500')
                }, 1500)
            }

        },
        generateVariables() {
            var str = this.form.application
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = str;
            var plainText = tempDiv.textContent || tempDiv.innerText || '';
            var newstr = plainText.match(/::(.*?)::/g);
            newstr = newstr?.filter(this.onlyUnique)
            this.form.variables = []
            newstr?.forEach((str) => {
                this.form.variables.push({variable: str, type: "", label: ""})
            })
        },
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
    }
}
</script>
<style>
#editor {
    height: 400px;
}

.copy-block:hover .copy-child {
    display: block;
}

#copy-code {
    display: none;
}
</style>
